import React, { useEffect } from 'react';

import * as echarts from 'echarts';
import { getLineChartWidth } from 'utils/charts';

export const LineChart = ({ id, width, height, date, graphData, grid = 12 }) => {
  useEffect(() => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, {
      width,
      height,
    });
    var option;

    option = {
      color : '#00778B',
      xAxis : {
        type     : 'category',
        data     : date,
        axisTick : {
          show : false,
        },
        axisLine : {
          lineStyle : {
            type : 'dashed',
          },
        },
        axisLabel : {
          fontFamily : 'Montserrat',
        },
      },
      legend : {
        show      : true,
        bottom    : '0%',
        left      : '0%',
        data      : ['1 = Not bothered at all. 5 = Extremely bothered'],
        textStyle : {
          fontFamily : 'Montserrat',
        },
        icon : 'circle',
      },
      yAxis : {
        type      : 'value',
        min       : 0,
        max       : 5,
        axisLabel : {
          fontFamily : 'Montserrat',
        },
      },
      grid : {
        top          : '15%',
        left         : '1%',
        right        : '0%',
        bottom       : '15%',
        containLabel : true,
      },
      series : [
        {
          data      : graphData,
          type      : 'line',
          name      : '1 = Not bothered at all. 5 = Extremely bothered',
          lineStyle : {
            width : 3,
            color : '#00778B',
            cap   : 'square',
          },
          symbolSize : 12,
          symbol     : 'circle',
        },
      ],
    };

    option && myChart.setOption(option);
    window.addEventListener('resize', () => {
      const newWidth = getLineChartWidth(width, grid);
      myChart.resize({
        width : newWidth
      });
    });
    const chartWidth = getLineChartWidth(width, grid);
    myChart.resize({
      width : chartWidth
    });
    // eslint-disable-next-line
  }, []);

  return <div
    id={id}
  />;
};
